import React from "react";
import "./Pagination.css";
import { ReactComponent as ArrowIcon } from "../../assets/icons/arrow-gac.svg";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  const getVisiblePages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  const visiblePages = getVisiblePages();

  return (
    <div className="pagination-container">
      {/* Prev Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="pagination-btn"
      >
        <ArrowIcon className="arrow-pagination left" />
      </button>

      {/* Page numbers */}
      <ul className="pagination-pages">
        {visiblePages.map((page, index) => (
          <li key={index}>
            {page === "..." ? (
              <span className="pagination-ellipsis">...</span>
            ) : (
              <button
                onClick={() => onPageChange(page)}
                className={`pagination-page ${
                  currentPage === page && "active"
                }`}
              >
                {page}
              </button>
            )}
          </li>
        ))}
      </ul>

      {/* Mobile text */}
      <span className="pagination-mobile">
        Page {currentPage} of {totalPages}
      </span>

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="pagination-btn"
      >
        <ArrowIcon className="arrow-pagination" />
      </button>
    </div>
  );
}
